import { IconProps } from '../../IconProps';

export function IconX(props: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            data-testid="IconX"
            {...props}
        >
            <path d="M17.8014 3L20.867 3L14.136 10.6384L22 21L15.8287 21L10.997 14.7033L5.4655 21L2.3999 21L9.5308 12.8303L2 3L8.3246 3L12.6898 8.752L17.8014 3ZM16.7284 19.2066L18.4279 19.2066L7.4315 4.7269L5.6055 4.7269L16.7284 19.2066Z" />
        </svg>
    );
}
